import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/**
 * Importing the application logo files from assets
 */
import applicationLogo from "../../assets/applicationLogotype.svg";
import applicationLogoWhite from "../../assets/applicationLogotypeWhite.svg";
import { UserType } from "../../api/Authentication";

/**
 * ApplicationLogo: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Displays the application logo based on the current theme
 * and has a localized alternate description.
 *
 * @param {*} props
 */
const ApplicationLogo = ({ intl, currentTheme, userType }) => {
  const applicationTitle = intl.formatMessage({ id: "application.title" });
  let edition = null;

  switch (userType) {
    case UserType.Teacher:
      edition = "application.edition.teachers";
      break;
    case UserType.Demo:
      edition = "application.edition.demo";
      break;
    default:
      break;
  }

  return (
    <Link
      to="/"
      className={`ax-application-logo${edition !== null ? " has-edition" : ""}`}
    >
      <img
        src={currentTheme === "dark" ? applicationLogoWhite : applicationLogo}
        alt={applicationTitle}
      />
      {edition !== null ? (
        <span className="ax-application-edition">
          <FormattedMessage
            id={edition}
            description="Application edition name for user group"
          />
        </span>
      ) : null}
    </Link>
  );
};

ApplicationLogo.propTypes = {
  /**
   * intl: intlShape
   * Localization wrapper provided by react-intl
   */
  intl: intlShape.isRequired,
  /**
   * currentTheme: String
   * Currently applied theme identifier
   */
  currentTheme: PropTypes.string.isRequired,
  /**
   * userType: String
   * Type of the currently logged in user
   */
  userType: PropTypes.string
};

ApplicationLogo.defaultProps = {
  userType: UserType.Demo
};

const mapStateToProps = state => ({
  currentTheme: state.settings.theme || "dark"
});

export default connect(mapStateToProps)(injectIntl(ApplicationLogo));



// WEBPACK FOOTER //
// ./src/components/topbar/ApplicationLogo.js